<template>
    <div>
        <div class="no-job">
            <div class="no-job-img">
                <img :src="no_job" alt="" width="340">
            </div>
        </div>
    </div>
</template>

<script setup>
import no_job from "@/assets/image/searchJob/no-job-icon.png";

</script>

<style lang='scss' scoped>
.no-job-img{
    margin-top: 88px;
     display: flex;
     justify-content: center;
}

</style>